import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { EndingCaseChip, type EndingCaseChipProps } from '@chess/api-ending-case/react';

// How the reader's ending went, for any screen. A component that can import
// `@chess/api-ending-case/react` uses its chip, dot, swatch and legend
// directly; a container may instead render this extension:
//   <app.Extension name="shared.endingCaseChip" params={{ case: 'slipped', onOpen }} />
// See docs/architecture/ending/plugin-shared-ending-case.md.
export const ENDING_CASE_CHIP_EXTENSION = 'shared.endingCaseChip';

export function setup(app: PiletApi) {
  const Chip: React.FC<{ params: EndingCaseChipProps }> = ({ params }) => <EndingCaseChip {...params} />;
  app.registerExtension<EndingCaseChipProps>(ENDING_CASE_CHIP_EXTENSION, Chip);
}
